export default __webpack_public_path__ + "static/media/Datchik-protechki-vody_about.8dcd5775.webp";